import React from 'react';

const GoogleMaps = ({mapId, title, address}) => {
  const normalizedAddress = (address || '').replace(/\s+/g, ' ').trim();
  const embedSrc = `https://www.google.com/maps?q=${encodeURIComponent(normalizedAddress)}&z=15&output=embed&hl=de&gl=DE`;

  return (
    <div id={mapId || 'google-maps'} className="google-maps">
      <iframe
        title={title || normalizedAddress}
        src={embedSrc}
        loading="lazy"
        allowFullScreen
      />
    </div>
  );
};

export default GoogleMaps;
